import axios from "axios";
import { toast } from "react-toastify";

import AuthService from "../../../services/auth.service";

const APP_URL = process.env.APP_URL;

export function sync({
  handleNotfound,
  subscriptionId,
  periodId,
  setIsLoading,
  setData,
  setButtons,
  setIsExpired,
  setActiveDateContent,
  setShowCalorieStatus,
  setTodayIndex,
  setActiveDate,
  showGuideModal,
  todayIndex,
}) {
  let config = {
    headers: {
      Authorization: `Bearer ${AuthService.getAccessToken()}`,
      channel: sessionStorage.getItem("channel"),
    },
  };

  config.params = {
    subscription_id: subscriptionId,
    period_id: periodId,
  };

  setIsLoading(true);

  axios
    .get(`${APP_URL}/api/v6/user-meals`, config)
    .then(function (response) {
      if (response.data.result.length === 0) {
        setData([]);
        return false;
      }

      if (response.data.result?.is_expired_period === true) {
        setIsExpired(true);
      }

      let todayIndexe = response.data.result.day_meals.findIndex(
        (day) => day.today
      );

      setData(response.data.result);
      setButtons(response.data.elements.buttons);
      setShowCalorieStatus(response.data.elements?.show_state);
      setTimeout(() => {
        setIsLoading(false);
      }, 1000);

      let activeIndex = localStorage.getItem("activeIndex");

      if (todayIndexe >= 0 && activeIndex === "") {
        setActiveDate(todayIndexe);
        setTodayIndex(todayIndexe);
        setActiveDateContent(response.data.result.day_meals[todayIndexe]);
      } else {
        if (activeIndex) {
          setActiveDate(todayIndex);
          setTodayIndex(todayIndex);
          setActiveDateContent(response.data.result.day_meals[activeIndex]);
        } else {
          setActiveDateContent(response.data.result.day_meals[todayIndex]);
        }
      }

      setIsLoading(false);

      if (
        !response?.data?.result.is_expired_period &&
        response?.data?.result?.is_fasting
      ) {
        let GuideButton = response?.data?.elements?.buttons.find(
          (button) => button.id === "btn_user_meals_fasting_info"
        );
        showGuideModal(subscriptionId, GuideButton?.content);
      }
    })
    .catch(function (error) {
      console.log(error);
      setIsLoading(false);

      if (!error.response) {
        handleNotfound();

        return false;
      }

      const statusCode = error.response.status;
      switch (statusCode) {
        case 422:
          const { errors } = error.response.data;

          for (const errorsKey in errors) {
            const error = errors[errorsKey];

            toast.error(error, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
          }
          break;

        case 401:
          AuthService.logout();
          window.location.replace("/");
          break;
        default:
          handleNotfound();

          break;
      }
    });
}
